export const TABLE_HEADER_SLIDE_MANAGEMENT = "table-header-slide-management";
export const TABLE_HEADER_SLIDE_MANAGEMENT_ADD_DIALOG =
  "TABLE_HEADER_SLIDE_MANAGEMENT_ADD_DIALOG";
export const TABLE_HEADER_PROJECT_LIST = "TABLE_HEADER_PROJECT_LIST";
export const TABLE_HEADER_ANNOTATION_CLASS_LIST =
  "TABLE_HEADER_ANNOTATION_CLASS_LIST";

export const FEATURE_OBSERVATION_ID = "FEATURE_OBSERVATION_ID";
export const FEATURE_STATUS = "FEATURE_STATUS";
export const FEATURE_ANNOTATION_ID = "FEATURE_ANNOTATION_ID";
export const FEATURE_STYLE = "FEATURE_STYLE";

export const ROLE_PATHOLOGIST = "pathologist";
export const ROLE_RESEARCHER = "researcher";
export const ROLE_IMAGE_OWNER = "image-owner";
export const ROLE_TESTER = "tester";
